import Vue from 'vue'
import Vuex, { StoreOptions } from 'vuex'

import entries from '@/store/entries'
import editor from '@/store/editor'
import share from '@/store/share'
import ui from '@/store/ui'
import settings from '@/store/settings'
import revision from '@/store/revision'
import { RootState } from '@/store/types'

Vue.use(Vuex)

const store: StoreOptions<RootState> = {
    modules: {
        entries,
        editor,
        share,
        ui,
        settings,
        revision
    }
}

export default new Vuex.Store<RootState>(store)
